/* LUNELACO — interactions (vanilla, no libraries) */
(function () {
  'use strict';
  // "Mostrar 3D siempre" in theme settings overrides the device's reduce-motion preference (script is deferred, body exists)
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches && !(document.body && document.body.hasAttribute('data-lu-3d-force'));

  /* ---------- Scroll reveal (one shared observer) ---------- */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lu-reveal:not(.lu-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lu-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('lu-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-lu-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-lu-count')) || 0;
      var suffix = el.getAttribute('data-lu-suffix') || '';
      if (reduce) { el.textContent = target + suffix; return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); obs.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Seven lights selector ---------- */
  function initLights(root) {
    (root || document).querySelectorAll('[data-lu-lights]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('.lu-light');
      var stage = wrap.querySelector('.lu-lights__stage');
      var img = wrap.querySelector('.lu-lights__img');
      var nameEl = wrap.querySelector('[data-lu-light-name]');
      var nmEl = wrap.querySelector('[data-lu-light-nm]');
      if (!btns.length || !stage) return;
      var timer = null, idx = 0;
      function activate(i, user) {
        idx = i;
        var b = btns[i];
        btns.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
        var color = b.getAttribute('data-color');
        stage.style.setProperty('--lu-light', color);
        wrap.style.setProperty('--lu-light', color);
        if (img) img.style.filter = b.getAttribute('data-filter') || 'none';
        if (nameEl) nameEl.textContent = b.getAttribute('data-name');
        if (nmEl) nmEl.textContent = b.getAttribute('data-nm');
        if (user && timer) { clearInterval(timer); timer = null; }
      }
      btns.forEach(function (b, i) { b.addEventListener('click', function () { activate(i, true); }); });
      activate(0, false);
      var auto = parseInt(wrap.getAttribute('data-autoplay'), 10) || 0;
      if (auto > 0 && !reduce) {
        timer = setInterval(function () { activate((idx + 1) % btns.length, false); }, auto * 1000);
      }
    });
  }

  /* ---------- Before / after ---------- */
  function initBeforeAfter(root) {
    (root || document).querySelectorAll('[data-lu-ba]').forEach(function (wrap) {
      wrap.querySelectorAll('.lu-ba__compare').forEach(function (cmp) {
        var range = cmp.querySelector('.lu-ba__range');
        if (!range) return;
        function set() { cmp.style.setProperty('--pos', range.value + '%'); }
        range.addEventListener('input', set);
        set();
      });
      var tabs = wrap.querySelectorAll('.lu-ba__tab');
      var panels = wrap.querySelectorAll('.lu-ba__panel');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (panels[i]) panels[i].classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-lu-gallery]').forEach(function (g) {
      var main = g.querySelector('.lu-gallery__main img');
      var thumbs = g.querySelectorAll('.lu-gallery__thumb');
      if (!main || !thumbs.length) return;
      var timer = null;
      var paused = false;
      function current() {
        return Array.prototype.indexOf.call(thumbs, g.querySelector('.lu-gallery__thumb.is-active'));
      }
      function show(t) {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = t.getAttribute('data-src');
          main.srcset = t.getAttribute('data-srcset') || '';
          main.alt = t.getAttribute('data-alt') || '';
          main.style.opacity = '1';
        }, 180);
      }
      function go(step) {
        var i = (Math.max(current(), 0) + step + thumbs.length) % thumbs.length;
        show(thumbs[i]);
      }
      // Auto-advance every 4 s; stops for good once the shopper picks a photo
      function start() {
        clearInterval(timer);
        if (thumbs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(function () { if (!paused && !document.hidden) go(1); }, 4000);
      }
      function stop() { clearInterval(timer); timer = null; }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { stop(); show(t); });
      });
      var prev = g.querySelector('[data-lu-gallery-prev]');
      var next = g.querySelector('[data-lu-gallery-next]');
      if (prev) prev.addEventListener('click', function () { stop(); go(-1); });
      if (next) next.addEventListener('click', function () { stop(); go(1); });
      var box = g.querySelector('.lu-gallery__main');
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { paused = false; });
      // Swipe on touch screens
      var x0 = null;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) { stop(); go(dx < 0 ? 1 : -1); }
      });
      start();
    });
  }

  /* ---------- Product form: variants, qty, add to cart (opens Dawn drawer) ---------- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noDecimals;
      if (k === 'amount_with_comma_separator') return parts[0] + ',' + parts[1];
      return withCommas;
    });
  }

  function initProductForms(root) {
    (root || document).querySelectorAll('[data-lu-product]').forEach(function (wrap) {
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-lu-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;
      var labels = { add: wrap.getAttribute('data-label-add'), soldout: wrap.getAttribute('data-label-soldout'), adding: wrap.getAttribute('data-label-adding') };
      var moneyFormat = wrap.getAttribute('data-money-format');
      var variantsEl = wrap.querySelector('[data-lu-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var selects = wrap.querySelectorAll('[data-lu-option]');

      function updateVariant() {
        if (!selects.length) return;
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) {
          if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = labels.soldout; }
          return;
        }
        idInput.value = v.id;
        document.querySelectorAll('[data-lu-price]').forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
        document.querySelectorAll('[data-lu-compare]').forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = formatMoney(v.compare_at_price, moneyFormat); el.hidden = false; }
          else { el.hidden = true; }
        });
        if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? labels.add : labels.soldout; }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

      var qty = form.querySelector('input[name="quantity"]');
      wrap.querySelectorAll('[data-lu-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-lu-qty'), 10);
          qty.value = Math.max(1, n);
        });
      });

      form.addEventListener('submit', function (ev) {
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!window.fetch || !drawer || typeof drawer.renderContents !== 'function') return; // native fallback -> /cart
        ev.preventDefault();
        if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = labels.adding; }
        var fd = new FormData(form);
        var sections = drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
        fd.append('sections', sections.join(','));
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { window.location.href = '/cart'; return; }
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (btn) { btn.disabled = false; if (btnLabel) btnLabel.textContent = labels.add; }
          });
      });
    });

    /* Mobile sticky buy bar */
    var sticky = document.querySelector('[data-lu-sticky]');
    var target = document.querySelector('[data-lu-add]');
    if (sticky && target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var below = e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !e.isIntersecting && below);
        });
      }).observe(target);
      var sbtn = sticky.querySelector('button');
      if (sbtn) sbtn.addEventListener('click', function () { target.click(); });
    }
  }

  /* ---------- COD product: option pills + quantity offer (drives the hidden selects above) ---------- */
  function initCod(root) {
    (root || document).querySelectorAll('[data-lu-cod]').forEach(function (wrap) {
      var variantsEl = wrap.querySelector('[data-lu-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var moneyFormat = wrap.getAttribute('data-money-format');
      var save = parseInt(wrap.getAttribute('data-save'), 10) || 0;
      var groups = wrap.querySelectorAll('[data-lu-cod-opt]');
      var qtyInput = wrap.querySelector('[data-lu-cod-qty]');

      function current() {
        var chosen = Array.prototype.map.call(groups, function (g) { return g.querySelector('select').value; });
        return variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      }

      function refresh() {
        groups.forEach(function (g, gi) {
          var sel = g.querySelector('select');
          g.querySelectorAll('.lu-cod__pill').forEach(function (p) {
            var on = p.getAttribute('data-value') === sel.value;
            p.classList.toggle('is-active', on);
            p.setAttribute('aria-checked', on ? 'true' : 'false');
            var probe = Array.prototype.map.call(groups, function (gg, i) { return i === gi ? p.getAttribute('data-value') : gg.querySelector('select').value; });
            var match = variants.find(function (x) { return x.options.every(function (o, i) { return o === probe[i]; }); });
            p.classList.toggle('is-off', !match || !match.available);
          });
          var chosenEl = g.querySelector('[data-lu-cod-chosen]');
          if (chosenEl) chosenEl.textContent = chosenEl.getAttribute('data-raw') === '1' ? sel.value : sel.value.charAt(0) + sel.value.slice(1).toLowerCase();
        });
        var v = current();
        if (!v) return;
        wrap.querySelectorAll('[data-lu-unit]').forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
        wrap.querySelectorAll('[data-lu-double]').forEach(function (el) { el.textContent = formatMoney(v.price * 2, moneyFormat); });
        wrap.querySelectorAll('[data-lu-bundle]').forEach(function (el) { el.textContent = formatMoney(v.price * 2 - save, moneyFormat); });
      }

      /* Swap the main gallery photo to the variant's own image (e.g. black body when "Negro" is picked) */
      function showVariantImage(v) {
        if (!v || !v.featured_image || !v.featured_image.src) return;
        var gallery = document.querySelector('.lu-cod [data-lu-gallery]');
        var main = gallery && gallery.querySelector('.lu-gallery__main img');
        if (!main) return;
        var file = v.featured_image.src.split('/').pop().split('?')[0];
        var thumb = Array.prototype.find.call(gallery.querySelectorAll('.lu-gallery__thumb'), function (t) { return (t.getAttribute('data-src') || '').indexOf(file) !== -1; });
        if (thumb) { thumb.click(); return; }
        var src = v.featured_image.src + (v.featured_image.src.indexOf('?') === -1 ? '?' : '&') + 'width=1200';
        main.style.opacity = '0';
        setTimeout(function () { main.src = src; main.srcset = ''; main.style.opacity = '1'; }, 180);
      }

      groups.forEach(function (g) {
        var sel = g.querySelector('select');
        g.querySelectorAll('.lu-cod__pill').forEach(function (p) {
          p.addEventListener('click', function () {
            sel.value = p.getAttribute('data-value');
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            refresh();
            showVariantImage(current());
          });
        });
      });

      wrap.querySelectorAll('.lu-cod__bundle').forEach(function (b, _, all) {
        b.addEventListener('click', function () {
          all.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
          if (qtyInput) {
            qtyInput.value = b.getAttribute('data-qty') || '1';
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      refresh();
    });
  }

  /* ---------- Savings calculator (honest math from real price) ---------- */
  function initSavings(root) {
    (root || document).querySelectorAll('[data-lu-savings]').forEach(function (card) {
      var range = card.querySelector('[data-lu-sv-range]');
      if (!range) return;
      var mask = parseInt(card.getAttribute('data-mask'), 10) || 0;
      var salon = parseInt(card.getAttribute('data-salon'), 10) || 0;
      var weeks = parseInt(card.getAttribute('data-weeks'), 10) || 52;
      var fmt = card.getAttribute('data-money-format');
      var nEl = card.querySelector('[data-lu-sv-n]');
      var salonEl = card.querySelector('[data-lu-sv-salon]');
      var perEl = card.querySelector('[data-lu-sv-per]');
      var saveEl = card.querySelector('[data-lu-sv-save]');
      function calc() {
        var n = parseInt(range.value, 10) || 1;
        var sessions = n * weeks;
        var salonYear = salon * sessions;
        var per = Math.round(mask / sessions);
        var save = Math.max(salonYear - mask, 0);
        if (nEl) nEl.textContent = n;
        if (salonEl) salonEl.textContent = formatMoney(salonYear, fmt);
        if (perEl) perEl.textContent = formatMoney(per, fmt);
        if (saveEl) saveEl.textContent = formatMoney(save, fmt);
        range.style.setProperty('--fill', ((n - 1) / 6 * 100) + '%');
      }
      range.addEventListener('input', calc);
      calc();
    });
  }

  /* ---------- Real-deadline countdown (hides itself when it ends) ---------- */
  function initOffers(root) {
    /* Struck-through offer prices: revert to the regular price once the real deadline passes */
    (root || document).querySelectorAll('[data-lu-offer-end]').forEach(function (el) {
      var end = new Date((el.getAttribute('data-lu-offer-end') || '').trim().replace(' ', 'T')).getTime();
      var on = el.querySelector('[data-offer-on]');
      var off = el.querySelector('[data-offer-off]');
      function check() {
        var expired = !end || isNaN(end) || Date.now() >= end;
        if (on) on.hidden = expired;
        if (off) off.hidden = !expired;
        return expired;
      }
      if (!check()) { var t = setInterval(function () { if (check()) clearInterval(t); }, 30000); }
    });
    (root || document).querySelectorAll('[data-lu-offer]').forEach(function (el) {
      var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
      var end = new Date(raw).getTime();
      var wrap = document.querySelector(el.getAttribute('data-hide-section')) || el;
      if (!end || isNaN(end)) { wrap.style.display = 'none'; return; }
      var parts = { d: el.querySelector('[data-lu-t="d"]'), h: el.querySelector('[data-lu-t="h"]'), m: el.querySelector('[data-lu-t="m"]'), s: el.querySelector('[data-lu-t="s"]') };
      function pad(x) { return (x < 10 ? '0' : '') + x; }
      var timer;
      function tick() {
        var diff = Math.floor((end - Date.now()) / 1000);
        if (diff <= 0) { wrap.style.display = 'none'; clearInterval(timer); return; }
        parts.d.textContent = pad(Math.floor(diff / 86400));
        parts.h.textContent = pad(Math.floor(diff % 86400 / 3600));
        parts.m.textContent = pad(Math.floor(diff % 3600 / 60));
        parts.s.textContent = pad(diff % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Generic real-deadline countdown text (bar, product urgency, popup) ---------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-lu-countdown]').forEach(function (el) {
      if (el.__luCd) return; el.__luCd = true;
      var end = new Date((el.getAttribute('data-end') || '').trim().replace(' ', 'T')).getTime();
      var msgEl = el.querySelector('[data-msg]');
      var tEl = el.querySelector('[data-timer]');
      var active = el.getAttribute('data-msg-active') || '';
      var last = el.getAttribute('data-msg-last') || active;
      var after = el.getAttribute('data-msg-after') || '';
      var wrap = el.closest('.shopify-section') && el.classList.contains('lu-ubar__inner') ? el.closest('.shopify-section') : el;
      function pad(x) { return (x < 10 ? '0' : '') + x; }
      var timer;
      function tick() {
        var diff = Math.floor((end - Date.now()) / 1000);
        if (!end || isNaN(end) || diff <= 0) {
          if (after) { if (msgEl) msgEl.textContent = after; if (tEl) tEl.textContent = ''; }
          else { wrap.style.display = 'none'; }
          clearInterval(timer); return;
        }
        var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
        if (diff < 86400) {
          if (msgEl) msgEl.textContent = last;
          if (tEl) tEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
          el.classList.add('is-last');
        } else {
          if (msgEl) msgEl.textContent = active;
          if (tEl) tEl.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        }
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Seasonal order-by countdown (days/hours/min/sec boxes; hides when the date passes) ---------- */
  function initSeason(root) {
    (root || document).querySelectorAll('[data-lu-season-cd]').forEach(function (el) {
      if (el.__luSeason) return; el.__luSeason = true;
      var end = new Date((el.getAttribute('data-end') || '').trim().replace(' ', 'T')).getTime();
      var u = {}; el.querySelectorAll('[data-u]').forEach(function (b) { u[b.getAttribute('data-u')] = b; });
      function pad(x) { return (x < 10 ? '0' : '') + x; }
      var timer;
      function tick() {
        var diff = Math.floor((end - Date.now()) / 1000);
        if (!end || isNaN(end) || diff <= 0) { el.style.display = 'none'; clearInterval(timer); return; }
        u.d.textContent = Math.floor(diff / 86400);
        u.h.textContent = pad(Math.floor(diff % 86400 / 3600));
        u.m.textContent = pad(Math.floor(diff % 3600 / 60));
        u.s.textContent = pad(diff % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Offer popup: once per session, exit intent (desktop) or delay (touch) ---------- */
  function initPopup(root) {
    var pop = (root || document).querySelector('[data-lu-popup]');
    if (!pop || pop.__luPop) return; pop.__luPop = true;
    var end = new Date((pop.getAttribute('data-end') || '').trim().replace(' ', 'T')).getTime();
    if (!end || isNaN(end) || Date.now() >= end) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var KEY = 'lu_offer_popup_seen';
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    var shown = false;
    function show() {
      if (shown || Date.now() >= end) return;
      shown = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      var btn = pop.querySelector('.lu-btn'); if (btn) btn.focus({ preventScroll: true });
    }
    function hide() { pop.classList.remove('is-open'); setTimeout(function () { pop.hidden = true; }, 300); }
    pop.querySelectorAll('[data-lu-popup-close]').forEach(function (b) { b.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) hide(); });
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    if (touch) {
      setTimeout(show, (parseInt(pop.getAttribute('data-delay'), 10) || 25) * 1000);
    } else {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
    }
  }

  /* ---------- Welcome popup: after a delay, then hidden for N days ---------- */
  function initWelcomePopup(root) {
    var pop = (root || document).querySelector('[data-lu-welcome]');
    if (!pop || pop.__luPop) return; pop.__luPop = true;
    if (window.Shopify && window.Shopify.designMode) return;
    var KEY = 'lu_welcome_popup_until';
    try { if (Date.now() < parseInt(localStorage.getItem(KEY), 10)) return; } catch (e) {}
    function show() {
      if (document.querySelector('.lu-popup.is-open')) return;
      var days = parseInt(pop.getAttribute('data-days'), 10) || 7;
      try { localStorage.setItem(KEY, String(Date.now() + days * 86400000)); } catch (e) {}
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      var btn = pop.querySelector('.lu-btn'); if (btn) btn.focus({ preventScroll: true });
    }
    function hide() { pop.classList.remove('is-open'); setTimeout(function () { pop.hidden = true; }, 300); }
    pop.querySelectorAll('[data-lu-popup-close]').forEach(function (b) { b.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) hide(); });
    setTimeout(show, (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000);
  }

  /* ---------- Hero: photo slideshow with thumbnails + pointer tilt ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('.lu-hero__visual').forEach(function (vis) {
      if (vis.__luHero) return; vis.__luHero = true;
      var slides = vis.querySelectorAll('.lu-hero__slide');
      var thumbs = vis.querySelectorAll('[data-lu-hero-thumb]');
      var current = 0, timer;
      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); t.setAttribute('aria-selected', k === current ? 'true' : 'false'); });
      }
      function play() { if (slides.length > 1 && !reduce) { clearInterval(timer); timer = setInterval(function () { show(current + 1); }, 4500); } }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-lu-hero-thumb'), 10) || 0); play(); }); });
      vis.addEventListener('mouseenter', function () { clearInterval(timer); });
      vis.addEventListener('mouseleave', play);
      play();

      var tilt = vis.querySelector('.lu-hero__tilt');
      var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (!vis.hasAttribute('data-lu-tilt') || !tilt || reduce || !fine) return;
      vis.addEventListener('pointermove', function (e) {
        var r = vis.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        tilt.style.setProperty('--lu-ry', ((x - .5) * 18).toFixed(2) + 'deg');
        tilt.style.setProperty('--lu-rx', ((.5 - y) * 14).toFixed(2) + 'deg');
        tilt.style.setProperty('--lu-gx', (x * 100).toFixed(0) + '%');
        tilt.style.setProperty('--lu-gy', (y * 100).toFixed(0) + '%');
      });
      vis.addEventListener('pointerleave', function () { ['--lu-rx', '--lu-ry'].forEach(function (p) { tilt.style.setProperty(p, '0deg'); }); });
    });
  }

  /* ---------- "Pide hoy, sale mañana": countdown to the daily cutoff in Ecuador time (UTC-5) ---------- */
  function initShip(root) {
    (root || document).querySelectorAll('[data-lu-ship]').forEach(function (el) {
      if (el.__luShip) return; el.__luShip = true;
      var title = el.querySelector('[data-lu-ship-title]'), time = el.querySelector('[data-lu-ship-time]');
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 24;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var ec = new Date(Date.now() - 5 * 3600 * 1000); // Ecuador clock read via UTC getters
        var day = ec.getUTCDay(), secs = ec.getUTCHours() * 3600 + ec.getUTCMinutes() * 60 + ec.getUTCSeconds();
        var left = cutoff * 3600 - secs;
        if (left <= 0) { left += 86400; day = (day + 1) % 7; }
        // Sat/Sun orders leave on Monday; the rest leave the next day
        title.textContent = (day === 6 || day === 0) ? el.getAttribute('data-monday') : el.getAttribute('data-tomorrow');
        time.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left % 3600 / 60)) + ':' + pad(left % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- 3D: tilt with the mouse (desktop) or with scrolling (touch), glare and depth ---------- */
  var fx = { list: [], seen: [], raf: 0, io: null, bound: false };
  // selector -> strength factor; "vars" = element already has its own 3D transform (only feed it the variables)
  var FX_TARGETS = [
    ['.lu-feature', 1], ['.lu-pain', 1], ['.lu-spot__media', .8], ['.lu-steps__media', .6],
    ['.lu-gallery__main', .7, 'nomobile'], ['.lu-compare__table', .3], ['.lu-faq__item', .25, 'noglare'],
    ['.lu-cta__media', .8, 'noglare'], ['.lu-ba__compare', .35, 'noglare nomobile'], ['.lu-hero__visual--card .lu-hero__tilt', 1, 'vars nopointer']
  ];
  function fxScroll() {
    fx.raf = 0;
    var vh = window.innerHeight || 1;
    fx.seen.forEach(function (it) {
      var r = it.el.getBoundingClientRect();
      var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2)));
      it.el.style.setProperty('--lu-rx', (p * it.max * 1.2).toFixed(2) + 'deg');
      it.el.style.setProperty('--lu-ry', (p * it.max * -.35).toFixed(2) + 'deg');
      it.el.style.setProperty('--lu-py', (p * -6).toFixed(1) + 'px');
    });
  }
  function initFx3d(root) {
    var body = document.body;
    if (!body.hasAttribute('data-lu-3d') || reduce) return;
    var strength = parseFloat(body.getAttribute('data-lu-3d-strength')) || 9;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var scrollMode = !fine && body.hasAttribute('data-lu-3d-scroll');
    var glare = fine && body.hasAttribute('data-lu-3d-glare');
    if (!fine && !scrollMode) return;
    FX_TARGETS.forEach(function (t) {
      var opts = t[2] || '';
      (root || document).querySelectorAll(t[0]).forEach(function (el) {
        if (el.__luFx) return;
        if (fine && opts.indexOf('nopointer') !== -1) return;
        if (scrollMode && opts.indexOf('nomobile') !== -1) return;
        el.__luFx = true;
        var it = { el: el, max: strength * t[1] };
        if (opts.indexOf('vars') === -1) el.classList.add('lu-3d');
        if (fine) {
          if (glare && opts.indexOf('noglare') === -1) {
            if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
            var g = document.createElement('span'); g.className = 'lu-3d__glare'; g.setAttribute('aria-hidden', 'true');
            el.appendChild(g);
          }
          var rect;
          el.addEventListener('pointerenter', function () { rect = el.getBoundingClientRect(); el.classList.add('is-tilting'); });
          el.addEventListener('pointermove', function (e) {
            if (!rect) rect = el.getBoundingClientRect();
            var x = (e.clientX - rect.left) / rect.width, y = (e.clientY - rect.top) / rect.height;
            el.style.setProperty('--lu-ry', ((x - .5) * it.max).toFixed(2) + 'deg');
            el.style.setProperty('--lu-rx', ((.5 - y) * it.max).toFixed(2) + 'deg');
            el.style.setProperty('--lu-gx', (x * 100).toFixed(0) + '%');
            el.style.setProperty('--lu-gy', (y * 100).toFixed(0) + '%');
            el.style.setProperty('--lu-px', ((x - .5) * 14).toFixed(1) + 'px');
            el.style.setProperty('--lu-py', ((y - .5) * 14).toFixed(1) + 'px');
          });
          el.addEventListener('pointerleave', function () {
            rect = null; el.classList.remove('is-tilting');
            ['--lu-rx', '--lu-ry', '--lu-px', '--lu-py'].forEach(function (p) { el.style.removeProperty(p); });
          });
        } else {
          // let the reveal animation finish before following the scroll quickly
          setTimeout(function () { el.classList.add('is-live'); }, 1000);
          fx.list.push(it);
          if (!fx.io) {
            fx.io = new IntersectionObserver(function (entries) {
              entries.forEach(function (e) {
                var found = fx.list.filter(function (x) { return x.el === e.target; })[0];
                if (!found) return;
                if (e.isIntersecting) { if (fx.seen.indexOf(found) === -1) fx.seen.push(found); }
                else fx.seen = fx.seen.filter(function (x) { return x !== found; });
              });
              if (!fx.raf) fx.raf = requestAnimationFrame(fxScroll);
            }, { rootMargin: '80px 0px' });
          }
          fx.io.observe(el);
        }
      });
    });
    if (scrollMode && !fx.bound) {
      fx.bound = true;
      var queue = function () { if (!fx.raf) fx.raf = requestAnimationFrame(fxScroll); };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
    }
  }

  function initAll(root) {
    try { initFx3d(root); } catch (e) { /* decorative only: never block the rest */ }
    initShip(root); initReveal(root); initCounters(root); initLights(root); initBeforeAfter(root); initGallery(root); initProductForms(root); initCod(root); initSavings(root); initOffers(root); initCountdowns(root); initSeason(root); initHero(root); initPopup(root); initWelcomePopup(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
